import axios from "axios";
import myAppConfig from "../../config";


const getNotification = () => {
  return axios
    .get(
      myAppConfig.api.ENDPOINT + `/api/v1/notification/get_notification`
    )
    .then((response) => {
      return response;
    });
};

const getLocalities = () => {
  return axios
    .get(myAppConfig.api.ENDPOINT + "/api/v1/tender-info/all_localities")
    .then((response) => {
      return response;
    });
};

const getTypeOfCalls = () => {
  return axios
    .get(myAppConfig.api.ENDPOINT + "/api/v1/tender-info/all_type_of_calls")
    .then((response) => {
      return response;
    });
};

const getTypeOfCompanies = () => {
  return axios
    .get(myAppConfig.api.ENDPOINT + "/api/v1/tender-info/all_type_of_companies")
    .then((response) => {
      return response;
    });
};

const postNotification = (data) => {
  return axios
    .post(
      myAppConfig.api.ENDPOINT + "/api/v1/notification/create_notification",
      data
    )
    .then((response) => {
      return response;
    });
};

const deleteNotification = (id) => {
  return axios
    .delete(
      myAppConfig.api.ENDPOINT + `/api/v1/notification/delete_notification/${id}`
    )
    .then((response) => {
      return response;
    });
};


const NotificationService = {
  getNotification,
  getLocalities,
  getTypeOfCalls,
  getTypeOfCompanies,
  postNotification,
  deleteNotification,
};

export default NotificationService;